import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3">
            实时追踪
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            每日漫画更新动态，第一时间掌握热门作品最新进度
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-primary-200"></div>

          <div className="flex flex-col gap-6">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-14">
                <div className="absolute left-2 md:left-4 top-1.5 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100 ring-2 ring-primary-200"></div>

                <div className="bg-background-50 rounded-xl p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}